import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import useHasAdminAuth from "../../hooks/useHasAdminAuth";
import { adminLogOut } from "../../state/adminAuth/adminAuthSlice";
import CircleLoader from "../../global/Loader/CircleLoader";
import { getCurrencies } from "../../state/common/commonSlice";

const PrivateLayoutAdmin = ({ children }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [hasAuth, setHasAuth] = useState(false);
  const isHasAuth = useHasAdminAuth();

  useEffect(() => {
    if (!isHasAuth) {
      dispatch(adminLogOut());
      navigate("/");
    } else setHasAuth(true);
  }, [dispatch, navigate, isHasAuth]);

  useEffect(() => {
    dispatch(getCurrencies());
  }, [dispatch, navigate]);

  // ## global logout function
  window.employerLogOut = () => {
    navigate("/");
    dispatch(adminLogOut());
  };

  if (!hasAuth) return <CircleLoader />;
  return children;
};

export default PrivateLayoutAdmin;
